export interface SimilarKanjiMember {
    symbol: string;
}

export interface SimilarKanjiGroup {
    id: string;
    members: SimilarKanjiMember[];
}

// Keep this deliberately curated (2-3 members each). Visual similarity is a
// learning judgement, not merely a glyph-distance calculation; the same data
// provides the choices for the look-alike quiz.
export const similarKanjiGroups: SimilarKanjiGroup[] = [
    { id: "personEnter", members: [{ symbol: "人" }, { symbol: "入" }] },
    { id: "earthScholar", members: [{ symbol: "土" }, { symbol: "士" }] },
    { id: "sunEye", members: [{ symbol: "日" }, { symbol: "目" }] },
    { id: "notYetEnd", members: [{ symbol: "未" }, { symbol: "末" }] },
    { id: "rightStone", members: [{ symbol: "右" }, { symbol: "石" }] },
    { id: "cowNoon", members: [{ symbol: "牛" }, { symbol: "午" }] },
    { id: "thousandDry", members: [{ symbol: "千" }, { symbol: "干" }] },
    { id: "kingJewel", members: [{ symbol: "王" }, { symbol: "玉" }] },
    { id: "bigDogThick", members: [{ symbol: "大" }, { symbol: "犬" }, { symbol: "太" }] },
    { id: "restBody", members: [{ symbol: "休" }, { symbol: "体" }] },
    { id: "swordPower", members: [{ symbol: "刀" }, { symbol: "力" }] },
    { id: "nameEach", members: [{ symbol: "名" }, { symbol: "各" }] },
    { id: "waitHold", members: [{ symbol: "待" }, { symbol: "持" }] },
    { id: "birdIsland", members: [{ symbol: "鳥" }, { symbol: "島" }] },
    { id: "askBetweenHear", members: [{ symbol: "問" }, { symbol: "間" }, { symbol: "聞" }] },
    { id: "shellSee", members: [{ symbol: "貝" }, { symbol: "見" }] },
    { id: "eastBundle", members: [{ symbol: "東" }, { symbol: "束" }] },
    { id: "whiteHundred", members: [{ symbol: "白" }, { symbol: "百" }] },
];
